import React from 'react';

import escape from 'lodash.escape';

import Highlight from '@pb/kit-component-highlight';

export const getMatchedChunks = (text: string, query: string) => {
    const startPos = text.toLowerCase().indexOf(query.toLowerCase());

    if (startPos !== -1 && query) {
        return [{
            startPos,
            endPos: startPos + query.length,
        }];
    }

    return [];
};

const getHighlightedText = (text: string, query: string) => {
    const escapedText = escape(text);
    const escapedQuery = escape(query);

    return (
        <Highlight
            showTitle={true}
            text={escapedText}
            matchedChunks={getMatchedChunks(escapedText, escapedQuery)}
        />
    );
};

export default getHighlightedText;
